<template>
  <div class="page-not-found">
    <nuxt-link class="page-not-found__logo-wrap" :to="localePath(ROUTE_NAMES.home)">
      <component
        :is="$i18n.locale === 'en' ? IconElioTaxEndorsed : IconAccesImpot"
        class="page-not-found__logo-svg"
      />
    </nuxt-link>
    <div class="page-not-found__block">
      <h2 class="page-not-found__block-title">
        {{ $t('pageNotFound') }}
      </h2>
      <Link class="page-not-found__block-link" :to="localePath(ROUTE_NAMES.home)">{{
        $t('goBack')
      }}</Link>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { ROUTE_NAMES } from '@/constants/route-names'
import IconAccesImpot from '@/components/_icons/IconAccesImpot.svg'
import IconElioTaxEndorsed from '@/components/_icons/IconElioTaxEndorsed.svg'
import Link from '@/components/Link/Link.vue'

export default {
  name: 'Error',
  layout: 'EmptyLayout',

  head() {
    return {
      title: `${this.$t('accesImpot')} | ${this.$t('pageNotFound')}`,
    }
  },

  components: {
    IconAccesImpot,
    IconElioTaxEndorsed,
    Link,
  },

  data() {
    return {
      ROUTE_NAMES,
      IconAccesImpot,
      IconElioTaxEndorsed,
    }
  },

  mounted() {
    this.showPage()
  },

  methods: {
    ...mapActions({
      showPage: 'page/show',
    }),
  },
}
</script>

<style lang="scss" scoped>
@import '@/layouts/background';

.page-not-found {
  @include blue-linear-gradient;
  display: flex;
  flex: 1;

  &__logo-wrap {
    position: absolute;
    top: 0;
    left: 10px;
    padding: 20px;
  }

  &__logo-svg {
    width: 152px;
    height: 24px;
  }

  &__block {
    margin: auto;
    padding: 100px 40px 60px;
    text-align: center;
    transform: translateY(-40px);
  }

  &__block-title {
    line-height: 1.3;
    margin-bottom: 10px;
  }

  & &__block-link {
    color: $color-text-light !important; // #bootstrap-override

    &:hover {
      color: $color-text !important; // #bootstrap-override
    }
  }
}
</style>

<i18n src="@/locales/page-not-found.json" />
